/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { AIMessageInput, AIModel, AIStreamResponse, AIToolCallResult, AIToolDefinition } from "./data-contracts";

/**
 * @description Generate an AI response in a conversation.
 * @tags site-ai
 * @name StreamAiResponseInSite
 * @summary Generate an AI response in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/ai/response
 * @secure
 */

// @ts-ignore
export const streamAIResponseInSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The ID of the previous response to continue from */
    previousResponseId?: string;
    /** The messages to send to the AI agent. */
    input: AIMessageInput[];
    model?: AIModel;
    /** Custom tools to provide to the AI agent. */
    tools?: AIToolDefinition[];
    /** Result of a tool call. */
    toolCall?: AIToolCallResult;
  };
  RequestHeaders: {};
  ResponseBody: AIStreamResponse;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ai/response",
  method: "post",
  streaming: true,
  tags: ["site-ai"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Experimental operation to get an existing AI response in a site.
 * @tags site-ai
 * @name StreamExistingAiResponseInSite
 * @summary Get an existing AI response in a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/ai/response/{responseId}
 * @secure
 */

// @ts-ignore
export const streamExistingAIResponseInSite: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the AI response */
    responseId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: AIStreamResponse;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ai/response/{responseId}",
  method: "get",
  streaming: true,
  tags: ["site-ai"],
  criticalityLevel: "low",
  deprecated: false,
};
